import React from "react";
import "./contentList.css";

export default function ContentList({ openChatWindow, ...props }) {

  const openChatBot = () => {
    openChatWindow();
  };

  if (props.linkTitle === "Open Chat Bot") {
    return (
      <section className="contentListWrapper">
        <div>
          <img className="bulleteIcon" src={props.icon} alt="bulletPointIcon" />
          <span
            onClick={openChatBot}
            target="_blank"
            download
            rel="noopener noreferrer"
          >
            {props.linkTitle}
          </span>
        </div>
      </section>
    );
  }

  return (
    <section className="contentListWrapper">
      <div>
        <img className="bulleteIcon" src={props.icon} alt="bulletPointIcon" />
        <a href={props.link} target="_blank" download rel="noopener noreferrer">
          {props.linkTitle}
        </a>
      </div>
    </section>
  );
}
